/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/state-in-constructor */
import '../../config';
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import axios from 'axios';
import ls from 'local-storage';
import _ from 'lodash';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import LinearProgress from '@material-ui/core/LinearProgress';
import {
  OlsTaxRow, OlsDiscountRow, OlsShippingRow, OlsTotalRow, OlsUxCodeRow, OlsTransferRow,
} from '../../component/OlsRow';
import OlsItemRow from '../../component/OlsItemRow/OlsItemRow';
import OrderRekeningPembayaran from '../../container/OrderRekeningPembayaran/OrderRekeningPembayaran';
import OrderAlamatLengkap from '../../container/OrderAlamatLengkap/OrderAlamatLengkap';
import OrderInformasiKurir from '../../container/OrderInformasiKurir/OrderInformasiKurir';
import OlsBottomNav from '../../container/OlsBottomNav/OlsBottomNav';
import Toast from '../../component/Toast/Toast';
import Confirm from '../../component/Confirm/Confirm';
import OlsExpiredDateTimeRow from '../../component/OlsRow/OlsExpiredDateTimeRow';
import OlsPaymentPaidRow from '../../component/OlsRow/OlsPaymentPaidRow';
import OlsRejectedRow from '../../component/OlsRow/OlsRejectedRow';
import WhatsAppLink from '../../component/WhatsAppLink/WhatsAppLink';
import OlsFooter from '../../component/OlsFooter/OlsFooter';
import OlsNavbarOrderView from '../../component/OlsNavbar/OlsNavbarOrderView';
import Divider from '@material-ui/core/Divider';

let isMounted = false;

const useStyles = (theme) => ({
  displayMobile: {
    display: 'block',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  displayDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
    },
  },
  page: {
    backgroundColor : theme.palette.color.background,
    maxWidth: theme.palette.width.appWidth,
    paddingTop: 62,
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  loadingTop: {
    height: 5,
    width: '100%',
    position: 'fixed',
    top: 0,
    left: 'auto',
    right: 'auto',
    paddingRight: '0px !important',
    zIndex: 1101,
  },
  content: {
    padding: 4,
    display: 'block',
    minHeight: 1000,
    '&::after': {
      content: '""',
      clear: 'both',
      display: 'table',
    },
  },
  itemWrapper: {
    marginTop: 0,
    padding: 0,
    display: 'block',
    width: '100%',
  },
  headerItemWrapper: {
    padding: '4px 4px 2px 4px',
  },
  headerItemContent: {
    borderRadius: '15px 15px 0px 0px',
    color: 'white',
    backgroundColor: theme.palette.primary.main,
    padding: 16,
    boxShadow: '1px 3px 1px #9E9E9E',
  },
  buttonStyle: {
    margin: '10px 0px',
    borderRadius: 0,
    padding: 15,
    fontWeight: 'bold',
  },
});

let base_url  = global.config.host;
if(base_url.length<1){
    base_url  = window.location.origin;
}
const { pathname }  = window.location;
const arrPath       = pathname.split('/');
let urlid = (arrPath && arrPath.length >= 2) ? arrPath[2] : '';
ls.set('urlid', urlid);

class OrderView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usr_info: ls.get('usr_info') || false,
      otl_info: ls.get(`${urlid}_info`) || {},
      order_info: {},
      item_list: [],
      bank_list: [],
      sc_order_info: ls.get(`${urlid}_ShoppingCart_OrderInfo`) || {},
      sc_item_list: [],
      loading: false,
      toastOpen: false,
      toastMessage: '',
      toastSeverity: 'info',
      confirmDelete: false,
    };
  }

  componentDidMount() {
    isMounted = true;

    let usr_info = ls.get('usr_info') || false;
    this.setState({
      usr_info: usr_info
    });

    if(usr_info===false){
      this.props.history.push('/home');
    } else {
      urlid = ls.get('urlid') || '';

      let otl_info = ls.get(`${urlid}_info`) || {};
      this.setState({
        otl_info: otl_info
      });

      /*
      const lsShoppingCartOrderInfo = `${urlid}_ShoppingCart_OrderInfo`;
      const lsShoppingCartItemList = `${urlid}_ShoppingCart_ItemList`;
      const orderInfo = ls.get(lsShoppingCartOrderInfo);
      if (_.isObject(orderInfo)) {
        if (_.isString(orderInfo.order_from_uxid)) {
          if(orderInfo.order_from_uxid===usr_info.usr_uxid){
            this.setState({ sc_order_info: orderInfo });
            const itemList = ls.get(lsShoppingCartItemList);
            if (_.isArray(itemList)) {
              this.setState({ sc_item_list: itemList });
            }
          }
        }
      }
      */
      
      this.otlOrderView();
    }
    window.scrollTo(0, 0);
  }

  otlOrderView = () => {
    if (_.isObject(this.props.match.params)) {
      if (_.isString(this.props.match.params.uxid)) {
        const { uxid } = this.props.match.params;
        this.setState({ loading: true });
        const formdata = new FormData();
        formdata.append('order_uxid', uxid);
        axios.post(base_url+'/olshop_api/order/order_view/', formdata).then((response) => {
          if (isMounted) {
            this.otlOrderInfo();

            this.setState({ loading: false });
            if (_.isObject(response.data.order_info)) {
              const orderInfoResp = response.data.order_info;
              if (_.isString(orderInfoResp.order_uxid)) {
                this.setState({ order_info: orderInfoResp });
              }
              
              if (_.isArray(response.data.item_list)) {
                const itemListResp = response.data.item_list;
                this.setState({ item_list: itemListResp });
              }
              if (_.isArray(response.data.bank_list)) {
                const bankistResp = response.data.bank_list;
                this.setState({ bank_list: bankistResp });
              }

              if (_.isString(orderInfoResp.order_number)) {
                document.title = `Order ${orderInfoResp.order_number}`;
              }
            }

            //= toast start
            if (_.isString(response.data.status)) {
              if (response.data.status === 'OK') {
                if (_.isString(response.data.message)) {
                  const { message } = response.data;
                  this.toastShow('success', message);
                }
                this.otlInfo();
              } else if (_.isString(response.data.message)) {
                const { message } = response.data;
                this.toastShow('error', message);
              }
            }
            //= toast end
          }
        });
      }
    }
  }

  otlOrderInfo = () => {
    urlid = ls.get('urlid') || '';
    const lsShoppingCartOrderInfo = `${urlid}_ShoppingCart_OrderInfo`;
    const lsShoppingCartItemList  = `${urlid}_ShoppingCart_ItemList`;
    const formdatao = new FormData();
    formdatao.append('urlid', urlid);
    axios.post(base_url+'/olshop_api/order/order_info/', formdatao).then((response) => {
      if (isMounted) {
        if (_.isObject(response.data.order_info)) {
          const orderInfoResp = response.data.order_info;
          if (_.isString(orderInfoResp.order_uxid)) {
            this.setState({ sc_order_info: orderInfoResp });
            ls.set(lsShoppingCartOrderInfo, orderInfoResp);
          }
        }
        if (_.isArray(response.data.item_list)) {
          const itemListResp = response.data.item_list;
          this.setState({ sc_item_list: itemListResp });
          ls.set(lsShoppingCartItemList, itemListResp);
        }
      }
    });
  }

  componentWillUnmount() {
    isMounted = false;
  }

  otlInfo = () => {
    urlid = ls.get('urlid') || '';
    const formdatau = new FormData();
    formdatau.append('urlid', urlid);
    axios.post(base_url+'/olshop_api/otl/otl_info/', formdatau).then((response) => {
      if (isMounted) {
        if (_.isObject(response.data.otl_info)) {
          urlid = response.data.otl_info.otl_urlid;
          this.setState({
            otl_info: response.data.otl_info,
          });
          ls.set('urlid', urlid);
          ls.set(`${urlid}_info`, response.data.otl_info);
        }
      }
    });
  }

  handleShoppingCartOpen = () => {
    if (isMounted) {
      this.props.history.push('/shoppingcart');
    }
  }

  handleGoBack = () => {
    if (this.props.history.length > 0) {
      this.props.history.goBack();
    }
  }

  handleAlamatLengkapChange = (dt) => {
    if (isMounted) {
      this.setState({ loading: true });
      const formdata = new FormData();
      formdata.append('order_uxid', this.state.order_info.order_uxid);
      formdata.append('order_shipping_realname', dt.order_shipping_realname);
      formdata.append('order_shipping_address1', dt.order_shipping_address1);
      formdata.append('order_shipping_address2', dt.order_shipping_address2);
      formdata.append('order_shipping_address3', dt.order_shipping_address3);
      formdata.append('order_shipping_address4', dt.order_shipping_address4);
      formdata.append('order_shipping_address5', dt.order_shipping_address5);
      formdata.append('order_shipping_phone', dt.order_shipping_phone);
      axios.post(base_url+'/olshop_api/order/order_address_update/', formdata).then((response) => {
        if (isMounted) {
          this.setState({ loading: false });
          if (_.isObject(response.data.order_info)) {
            const orderInfoResp = response.data.order_info;
            if (_.isString(orderInfoResp.order_uxid)) {
              this.setState({ order_info: orderInfoResp });
            }
          }
          if (_.isArray(response.data.item_list)) {
            const itemListResp = response.data.item_list;
            this.setState({ item_list: itemListResp });
          }
          //= toast start
          if (_.isString(response.data.status)) {
            if (response.data.status === 'OK') {
              if (_.isString(response.data.message)) {
                const { message } = response.data;
                this.toastShow('success', message);
              }
            } else if (_.isString(response.data.message)) {
              const { message } = response.data;
              this.toastShow('error', message);
            }
          }
          //= toast end
        }
      });
    }
  }

  handleLokasiPengirimanChange = (dt) => {
    if (isMounted) {
      this.setState({ loading: true });
      const formdata = new FormData();
      formdata.append('order_uxid', this.state.order_info.order_uxid);
      formdata.append('order_shipping_province_id', dt.order_shipping_province_id);
      formdata.append('order_shipping_province_name', dt.order_shipping_province_name);
      formdata.append('order_shipping_city_id', dt.order_shipping_city_id);
      formdata.append('order_shipping_city_name', dt.order_shipping_city_name);
      formdata.append('order_shipping_city_type', dt.order_shipping_city_type);
      formdata.append('order_shipping_subdistrict_id', dt.order_shipping_subdistrict_id);
      formdata.append('order_shipping_subdistrict_name', dt.order_shipping_subdistrict_name);
      axios.post(base_url+'/olshop_api/order/order_location_update/', formdata).then((response) => {
        if (isMounted) {
          this.setState({ loading: false });
          if (_.isObject(response.data.order_info)) {
            const orderInfoResp = response.data.order_info;
            if (_.isString(orderInfoResp.order_uxid)) {
              this.setState({ order_info: orderInfoResp });
            }
          }
          if (_.isArray(response.data.item_list)) {
            const itemListResp = response.data.item_list;
            this.setState({ item_list: itemListResp });
          }
          //= toast start
          if (_.isString(response.data.status)) {
            if (response.data.status === 'OK') {
              if (_.isString(response.data.message)) {
                const { message } = response.data;
                this.toastShow('success', message);
              }
            } else if (_.isString(response.data.message)) {
              const { message } = response.data;
              this.toastShow('error', message);
            }
          }
          //= toast end
        }
      });
    }
  }

  toastShow = (severity, message) => {
    this.setState({
      toastOpen: true,
      toastMessage: message,
      toastSeverity: severity,
    });
  }

  toastOnClose = () => {
    this.setState({
      toastOpen: false,
    });
  }

  handleOrderDelete = () => {
    this.setState({
      confirmDelete: true,
    });
  }

  confirmDeleteClose = () => {
    this.setState({
      confirmDelete: false,
    });
  }

  confirmDeleteYes = () => {
    if (isMounted) {
      this.setState({
        confirmDelete: false,
      });
      this.setState({ loading: true });
      const formdata = new FormData();
      formdata.append('order_uxid', this.state.order_info.order_uxid);
      axios.post(base_url+'/olshop_api/order/order_delete/', formdata).then((response) => {
        if (isMounted) {
          this.setState({ loading: false });
          if (_.isObject(response.data.order_info)) {
            const orderInfoResp = response.data.order_info;
            if (_.isString(orderInfoResp.order_uxid)) {
              this.setState({ order_info: orderInfoResp });
            }
          }
          if (_.isArray(response.data.item_list)) {
            const itemListResp = response.data.item_list;
            this.setState({ item_list: itemListResp });
          }
          //= toast start
          if (_.isString(response.data.status)) {
            if (response.data.status === 'OK') {
              if (_.isString(response.data.message)) {
                const { message } = response.data;
                this.toastShow('success', message);
              }
            } else if (_.isString(response.data.message)) {
              const { message } = response.data;
              this.toastShow('error', message);
            }
          }
          //= toast end
          if (this.props.history.length > 0) {
            this.props.history.goBack();
          }
        }
      });
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        {!_.isString(this.state.order_info.order_uxid)
          && (
            <div style={{ paddingBottom: 56 }} >
              <div className={classes.page}>
                  <div style={{ height: 18 }}>
                  </div>
                  <div style={{ paddingBottom: 56 }}>
                    <div className={classes.content}>
                      <div style={this.state.loading ? { display: 'none' } : {}}>
                        <div style={{ marginTop: '100px', textAlign: 'center' }}>
                          <ShoppingBasketIcon style={{ textAlign: 'center', color: '#808080', fontSize: 140 }} />
                        </div>
                        <div style={{ textAlign: 'center' }}>
                          <Typography style={{ color: '#808080' }} variant="h6" noWrap>
                            Tidak dapat menampilkan order
                          </Typography>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
              <Divider />
              <OlsFooter outlet={this.state.otl_info} />
            </div>
          )}
        {_.isString(this.state.order_info.order_uxid)
          && (
            <div style={{ paddingBottom: 56 }} >
              <div className={classes.page}>

                    <div style={{ height: 18 }}>
                    </div>
                  
                    <div style={{ paddingBottom: 56 }}>
                    <div className={classes.content}>
                      <OrderAlamatLengkap editable={(this.state.order_info.order_step === 'MENUNGGU')} data={this.state.order_info} onChange={this.handleAlamatLengkapChange} />

                      <div className={classes.headerItemWrapper}>
                        <div className={classes.headerItemContent}>
                          <Typography variant="h6" noWrap>
                            Daftar Belanja
                          </Typography>
                        </div>
                      </div>

                      <div className={classes.itemWrapper}>
                        {
                          this.state.item_list.map((item, index) => <OlsItemRow key={index} data={item} onOpen={() => { }} />)
                        }
                      </div>

                      {this.state.order_info.order_tax_percent > 0 && <OlsTaxRow percent={this.state.order_info.order_tax_percent} value={this.state.order_info.order_tax_value} />}
                      {this.state.order_info.order_shipping_cost > 0 && <OlsShippingRow label="Biaya Pengiriman" value={this.state.order_info.order_shipping_cost} />}
                      {this.state.order_info.order_discount_value > 0 && <OlsDiscountRow discount_value={this.state.order_info.order_discount_value} discount_type={this.state.order_info.order_discount_type} discount_price={this.state.order_info.order_discount_price} />}
                      <OlsTotalRow label="Jumlah Total" value={this.state.order_info.order_total} />


                      {this.state.order_info.order_step === 'TAGIHAN'
                        && (
                          <div>
                            <OlsUxCodeRow label="Kode Unik" value={this.state.order_info.order_uxcode} />
                            <OlsTransferRow label="Nilai Transfer" value={this.state.order_info.order_cash_pay} />
                            <OlsExpiredDateTimeRow datetime={this.state.order_info.order_expired_datetime} />
                            <OrderRekeningPembayaran data={this.state.bank_list} />
                          </div>
                        )}

                      {(this.state.order_info.order_payment_status === 'PAID')
                        && (this.state.order_info.order_step === 'TAGIHAN')
                        && (
                          <div>
                            <OlsPaymentPaidRow />
                          </div>
                        )}

                      {this.state.order_info.order_status === 'DITOLAK'
                        && (
                          <div>
                            <OlsRejectedRow />
                          </div>
                        )}

                      {(this.state.order_info.order_step === 'TAGIHAN' || this.state.order_info.order_step === 'DIKIRIM' || this.state.order_info.order_step === 'SELESAI')
                        && (this.state.order_info.order_status !== 'DITOLAK')
                        && (this.state.order_info.order_shipping_code !== '') && (
                          <OrderInformasiKurir data={this.state.order_info} />
                        )}

                      {this.state.order_info.order_expired_status === '1'
                        && (
                          <div>
                            <Button className={classes.buttonStyle} fullWidth variant="contained" color="secondary" onClick={this.handleOrderDelete}>
                              HAPUS ORDER
                            </Button>
                          </div>
                        )}

                      </div>
                    </div>
              </div>
              <Divider />
              <OlsFooter outlet={this.state.otl_info} />
              <Confirm open={this.state.confirmDelete} text="Yakin ingin membatalkan order?" onClose={this.confirmDeleteClose} onYes={this.confirmDeleteYes} />
            </div>
          )}

        <OlsNavbarOrderView 
          value="order" 
          title={this.state.order_info.order_number ? `Order ${this.state.order_info.order_number}` : `Order`}
          text={this.state.order_info.order_number ? `Nomor order ${this.state.order_info.order_number} : ` : `Hallo`}
          outlet={this.state.otl_info} 
          itemCount={_.size(this.state.sc_item_list)} 
          onCartClick={this.handleShoppingCartOpen} 
          onBackClick={this.handleGoBack}
        />

        <div className={classes.displayMobile} >
          <WhatsAppLink phone={this.state.otl_info.otl_whatsapp} label="Butuh Bantuan ?" text={this.state.order_info.order_number ? `Nomor order ${this.state.order_info.order_number} : ` : `Hallo`} />
          <OlsBottomNav />
        </div>

        <div className={classes.loadingTop} >
          <LinearProgress style={this.state.loading ? {} : { display: 'none' }} />
        </div>

        <Toast open={this.state.toastOpen} message={this.state.toastMessage} severity={this.state.toastSeverity} onClose={this.toastOnClose} />
      </div>
    );
  }
}

export default withStyles(useStyles)(OrderView);
